import { useQuery } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getWalletLimits } from 'services/WalletsService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { Currencies } from 'types/types'

export const useWalletLimits = (currencyCode: Currencies, walletId: number, enabled = false) => {
  return useQuery(
    reactQueryKeys.getWalletLimits(currencyCode, walletId),
    () => getWalletLimits(currencyCode, walletId),
    {
      onError: (error: BaseErrorResponse) => {
        logSentryError(
          'Pay - getWalletLimits - error from get withdrawal limits for selected currency',
          error,
          {
            walletId,
            currencyCode,
          }
        )
      },
      enabled,
    }
  )
}
